import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { message } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Logout } from "../../actions/Auth/Auth";
import usercircle from "../../Assets/Images/usercircle.svg";
import settings from "../../Assets/Images/settings.svg";
import logOut from "../../Assets/Images/logOut.svg";
import diamond from "../../Assets/Images/icons/diamond.png";
import "../../Assets/Styles/pages/header.scss";
import { usePremiumStatus } from "../../hooks/usePremiumStatus";
import PremiumGateDialog from "../Common/PremiumGateDialog";

interface ProfileProps {
  setOpenSettings: (value: boolean) => void;
  item?: "start" | "center" | "end";
  anchor: React.RefObject<HTMLElement | null>;
}

const Profile: React.FC<ProfileProps> = ({ setOpenSettings, item = "start", anchor }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const userSliceState = useSelector((state: any) => state["userSlice"]);
  const templateCount = Array.isArray(userSliceState?.template)
    ? userSliceState.template.length
    : Object.keys(userSliceState?.template || {}).length;
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const isPremium = usePremiumStatus();
  const [showGateDialog, setShowGateDialog] = useState(false);

  const handleClick = () => {
    // Add a delay before setting the anchorEl to null
    if (anchor.current === anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(anchor.current);
    }
  };
  const handleMouseEnter = () => {
    setIsMouseOver(true);
  };

  const handleMouseLeave = () => {
    setIsMouseOver(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleItemClick = (event: React.MouseEvent<HTMLLIElement>) => {
    const action = event.currentTarget.getAttribute("data-action");
    if (action === "profile") {
      history.push("/profile");
    } else if (action === "settings") {
      setOpenSettings(true);
      setTimeout(() => {
        message.info(
          "Please turn off the toggle to modify the file format or image resolution.",
          5
        );
      }, 1000);
    } else if (action === "logout") {
      dispatch(Logout());
      // If user signs out from protected/create flows, take them back home.
      if (location.pathname === "/addtemplate" || location.pathname === "/profile") {
        history.push("/home");
      }
    }
    handleClose();
  };

  return (
    <Row
      // No text content here to truncate (just the avatar) -- `text-truncate` (overflow:
      // hidden) was clipping the diamond "Pro" badge, which intentionally sits partly below
      // the avatar's edge (`bottom: -4px` in .profile-diamond-badge).
      className={`justify-content-${item} m-0 p-0 align-items-center flex-nowrap position-relative`}
    >
      <div className="profile-avatar-container cursor-pointer pointer" onClick={handleClick}>
        <Avatar
          className={`${item === "center" ? "size_5rem " : "w_40x40"} p-0 m-1`}
          alt="User Profile"
          src={
            userSliceState.user_Auth.photoURL
              ? userSliceState.user_Auth.photoURL
              : usercircle
          }
        />
        {isPremium && (
          <div className="profile-diamond-badge">
            <img src={diamond} alt="Premium" />
          </div>
        )}
      </div>
      <Menu
        // sx={{ ml: '-3rem', mt: '4rem', p: '0' }}
        className="position-absolute p-0 menuDiv"
        anchorEl={anchorEl}
        open={anchorEl !== null}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            backgroundColor: "#ffffff",
            color: "#000000",
            borderRadius: "0.5rem",
          }
        }}
      >
        <div className="profileMenuDiv profile-menu-custom-width text_13 productSans position-relative">
          <div
            className={` ${isMouseOver && "triangle_up_hover"} triangle_up`}
          ></div>
          <MenuItem className=" profileMenu p-0" onClick={handleItemClick}>
            <Row
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              className="d-flex align-items-center position-relative border-bottom  px-1 py-3 line_height_100pc w-100 m-0 p-0"
            >
              <Col
                md={3}
                className="m-0 p-0 d-flex flex-column justify-content-center align-items-center"
              >
                <div className="profile-avatar-container">
                  <Avatar
                    className="w_40x40"
                    src={
                      userSliceState.user_Auth.photoURL
                        ? userSliceState.user_Auth.photoURL
                        : usercircle
                    }
                  />
                  {isPremium && (
                    <div className="profile-diamond-badge">
                      <img src={diamond} alt="Premium" />
                    </div>
                  )}
                </div>
              </Col>
              <Col className="m-0 p-0 d-flex flex-column justify-content-center align-items-start">
                <Row className="m-0 p-0 mb-1 text_19 productSansLight profile-username-text">
                  {userSliceState.user_Auth.displayName}
                </Row>
                <Row className="m-0 p-0 text_11">
                  {userSliceState.user_Auth.email}
                </Row>
                <Row className="m-0 p-0 text_11 mt-1 profile-level-text">
                  Level: {isPremium ? "Pro" : "Free"}
                </Row>
              </Col>
            </Row>
          </MenuItem>
          {isPremium && (
            <div className="profile-template-stats-wrapper">
              <div className="profile-template-stats-box">
                <div className="profile-template-stat-col">
                  <div className="profile-template-stat-label">TOTAL TEMPLATES</div>
                  <div className="profile-template-stat-value">{templateCount}</div>
                </div>
                <div className="profile-template-stat-divider"></div>
                <div className="profile-template-stat-col">
                  <div className="profile-template-stat-label">SYNCED TEMPLATES</div>
                  <div className="profile-template-stat-value">{templateCount}</div>
                </div>
              </div>
            </div>
          )}
          {!isPremium && (
            <div className="px-3 py-3 border-bottom d-flex flex-column align-items-center text-center w-100 profile-premium-container">
              <span className="text_13 productSansLight mb-3 text-wrap profile-premium-text">
                You can only use 1 Template. To unlock more features you can buy premium Plan
              </span>
              <button
                className="d-flex align-items-center justify-content-center border-0 px-3 py-2 profile-premium-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowGateDialog(true);
                  handleClose();
                }}
              >
                <img src={diamond} alt="premium" className="profile-premium-icon" />
                Unlock Premium Features
              </button>
            </div>
          )}
          <MenuItem
            className=" profileMenu p-0"
            onClick={handleItemClick}
            data-action="profile"
          >
            <Row className="d-flex align-items-center border-bottom px-1 py-3 line_height_100pc w-100 m-0 p-0">
              <Col
                md={3}
                className="m-0 p-0 d-flex flex-column justify-content-center align-items-center"
              >
                <img alt="profile" className="w_21r" src={usercircle} />
              </Col>
              <Col className="m-0 p-0 d-flex flex-column justify-content-center align-items-start">
                <Row className="m-0 p-0">My Profile</Row>
              </Col>
            </Row>
          </MenuItem>
          <MenuItem
            className=" profileMenu p-0"
            onClick={handleItemClick}
            data-action="settings"
          >
            <Row className="d-flex align-items-center border-bottom px-1 py-3 line_height_100pc w-100 m-0 p-0">
              <Col
                md={3}
                className="m-0 p-0 d-flex flex-column justify-content-center align-items-center"
              >
                <img alt="settings" className="w_21r" src={settings} />
              </Col>
              <Col className="m-0 p-0 d-flex flex-column justify-content-center align-items-start">
                <Row className="m-0 p-0">Settings</Row>
              </Col>
            </Row>
          </MenuItem>
          <MenuItem
            className=" profileMenu p-0"
            onClick={handleItemClick}
            data-action="logout"
          >
            <Row className="d-flex align-items-center px-1 py-3 line_height_100pc w-100 m-0 p-0">
              <Col
                md={3}
                className="m-0 p-0 d-flex flex-column justify-content-center align-items-center"
              >
                <img className="w_21r" src={logOut} alt="Logout" />
              </Col>
              <Col className="m-0 p-0 d-flex flex-column justify-content-center align-items-start">
                <Row className="m-0 p-0">Logout</Row>
              </Col>
            </Row>
          </MenuItem>
        </div>
      </Menu>
      <PremiumGateDialog
        open={showGateDialog}
        onClose={() => setShowGateDialog(false)}
        title="Upgrade to Pro"
        message="Get unlimited templates and unlock all premium features today."
      />
    </Row>
  );
};

export default Profile;
